import { Controller } from 'stimulus'

export default class extends Controller {
    scroll() {
        let top = $(this.element).closest('.header').next().position().top
        $('body,html').animate({scrollTop: top}, 600)
    }
}
